module.exports = __webpack_public_path__ + "img/george-forsyth.6937ffea.png";